module.exports = __webpack_public_path__ + "static/media/crpt.92521c34.svg";